import * as React from "react";

function SvgComponent(props) {
  return (
    <img
      src="/Herbloom.png" 
      alt="logo"
      width={60}
      height={10}
    />
  );
}

export default SvgComponent;
